import { IChartTableComboStyle } from '../models/index.js';
export const chartTableComboStyle: IChartTableComboStyle = {
	children: {
		chartWrapper: {
			margin: {
				bottom: '20px',
			},
		},
	},
};
